import React, { useContext, useEffect } from 'react';

import * as routes from '../routes/routes';

import { GlobalSettingsContext } from '../firebase/GlobalSettingsContext';
import { UserDataContext } from '../firebase/UserDataContext';
import { useLocation } from 'react-router';
import { JudgeScoresheetPage } from '../pages/JudgeScoresheetPage';
import { ROLES } from '../components/misc/Utils';
import { useNavigate } from 'react-router-dom';
import LoadingSkeleton from '../components/misc/LoadingSkeleton';

const JudgeActionsRouter = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { globalSettings } = useContext(GlobalSettingsContext)
    const { user } = useContext(UserDataContext)

    useEffect(() => {
        if (Object.keys(user).length > 0 && !user.loggedIn) {
            navigate(routes.SIGN_IN)
        }
    }, [user, navigate])
    switch (true) {
        case Object.keys(globalSettings).length === 0 || Object.keys(user).length === 0:
            return <LoadingSkeleton />
        case ![ROLES.ADMIN, ROLES.JUDGE].includes(user.role):
            return <div>Not authorized to see this view, contact an Adminstrator</div>
        case location.pathname.includes(routes.EVENT_SCORESHEET_PAGE):
            return <JudgeScoresheetPage />
        default:
            return <div>Unknown Route. Contact an Administrator</div>

    }
}

export default JudgeActionsRouter
